import { useMatch } from "react-router";

import { portalRoutes } from "@/router/routes/portalRoutes";

/**
 * True while a 2FA setup/change step is open below the Login tab. The 2FA flow
 * is route-driven (nested routes under `security.base`), not an
 * `userAccountStateAtom` flag, so every consumer that has to react to it reads
 * the route through this hook.
 */
export const useIsInSecuritySubFlow = (): boolean => {
  const securityMatch = useMatch(portalRoutes.user.security.base + "/*");

  // The splat holds whatever follows the base, so a trailing slash ("") on
  // the Login tab itself does not count as a sub-flow.
  return !!securityMatch?.params["*"];
};
